import { Box, Container, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/common'
import { finalCTAContent } from '@/data/content'

/**
 * Final CTA Section Component
 * Closing call-to-action before contact form
 */
export const FinalCtaSection = () => {
  const navigate = useNavigate()

  const handleCTAClick = () => {
    navigate('/contact')
  }

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        background: 'linear-gradient(135deg, #0891b2 0%, #2563eb 100%)',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.75rem' },
            mb: 2,
            lineHeight: 1.2,
          }}
        >
          {finalCTAContent.heading}
        </Typography>

        <Typography
          variant="h5"
          component="p"
          sx={{
            fontWeight: 400,
            fontSize: { xs: '1.125rem', md: '1.5rem' },
            mb: 4,
            opacity: 0.95,
          }}
        >
          {finalCTAContent.subheading}
        </Typography>

        <Button
          variant="primary"
          size="large"
          onClick={handleCTAClick}
          sx={{
            bgcolor: 'white',
            color: 'primary.main',
            px: 4,
            py: 1.5,
            fontSize: '1.125rem',
            '&:hover': {
              bgcolor: 'grey.100',
            },
          }}
        >
          {finalCTAContent.cta.text}
        </Button>

        <Typography
          variant="body2"
          sx={{
            mt: 3,
            opacity: 0.9,
            fontStyle: 'italic',
          }}
        >
          {finalCTAContent.note}
        </Typography>
      </Container>
    </Box>
  )
}
